import { jsx as _jsx } from "react/jsx-runtime";
import { useAuth } from '@src/hooks/useAuth';
import { hasPermission } from 'pe-core-frontend';
import { Navigate } from 'react-router-dom';
export const AuthRequired = ({ children, permissions = [], onlyClaimsProcessor, onlyManager, onlyMemberSupport, }) => {
    const { currentUser, isSuperuser, isClaimsProcessor, isManager, loading, isMemberSupport } = useAuth();
    let canAccess = false;
    if (isSuperuser) {
        canAccess = true;
    }
    if (!canAccess && onlyClaimsProcessor) {
        canAccess = isClaimsProcessor;
    }
    if (!canAccess && onlyManager) {
        canAccess = isManager;
    }
    if (!canAccess && onlyMemberSupport) {
        canAccess = isMemberSupport;
    }
    if (!canAccess) {
        canAccess = permissions.length > 0 && hasPermission(currentUser, ...permissions);
    }
    if (!currentUser) {
        if (!loading) {
            return _jsx(Navigate, { to: '/login' });
        }
    }
    if (!loading && !canAccess) {
        return (_jsx("div", { className: 'fontWeight--600 padding--12 fontSize--lg', children: "You do not have permission to access this page" }));
    }
    return _jsx("div", { children: children });
};
